module.exports = __webpack_public_path__ + "media/images/landing/ar/main@2x-c26680064f15b1ce89d2d9262de7545e.webp";